module.exports = __webpack_public_path__ + "static/media/copy_link_white.322ed72e.svg";